import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { COMPARE_PRICE, PRICE } from '../data/content';
const recap = ['6 tomów', '5 bonusów', '240 stron', '3 grupy'];
const reassurances = ['Natychmiastowy dostęp cyfrowy', 'PDF do druku', '7 dni gwarancji satysfakcji'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15c2dl6weyjqu">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbk4brt9s72u" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1ec7jfclyla2w">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t2evnaldhwv5">
          Twoje zajęcia aqua aerobiku mogą być <em className="text-red-700" data-id="element-118" data-mp="223mjeyq9jfaz">gotowe już dziś.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="221js8bddjg4o">
          Zamiast szukać ćwiczeń, pisać każde zajęcia samodzielnie i spędzać niedzielne wieczory
          na przygotowaniach, masz uporządkowany pakiet aqua aerobiku na cały sezon. Więcej czasu na to,
          co naprawdę ważne:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="x41wm2yfl9ab">
          Twoi uczestnicy. Twoja grupa. Twoje życie poza basenem.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="120ilizdgfrog">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1b31kh8e4dk5f">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b1qgb7griads">
          <s className="mr-3 align-middle text-3xl text-slate-900/40 sm:text-4xl" data-id="element-124" data-mp="1fwcv7km1yl2m"><span className="sr-only" data-id="element-125" data-mp="1ks1pp9j7tbs2">Zamiast </span>{COMPARE_PRICE}</s>
          {PRICE}
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-126" data-mp="1ptqyeiiytdcz">Jednorazowa płatność – bez abonamentu.</p>

        <div className="mt-8 flex justify-center" data-id="element-127" data-mp="1tuuhrf081riy">
          <CtaButton className="w-full sm:w-auto" data-id="element-128" data-mp="3quoxkvn10vpe" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-129" data-mp="3qux7qfrrlmww">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-130" data-mp="3hl6rarsgke7">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-131" data-mp="3iw8l51obi2o" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}